/*!
 * Funnelback search autocomplete / concierge panel.
 * Extracted from QGov SWE 4.4.0 qg-main.js (modules 398 + 937).
 *
 * Requires: jQuery
 *
 * The search form must have:
 *   - id="qg-global-search-form"
 *   - data-suggestions="<funnelback suggest.json URL>"
 *   - data-results-url="<funnelback search.json URL>"
 *   - an <input> with class "qg-search-site__input"
 *
 * Concierge panels inside the form:
 *   .qg-search-concierge-initial   – shown when input is empty/focused
 *   .qg-search-concierge-help      – shown when suggestions are available
 *     .qg-search-concierge-group.suggestions  – suggestion list
 *     .qg-search-concierge-group.highlight    – featured service
 *     .qg-search-concierge-group.helper       – related services
 */

(function () {
  'use strict';

  // ---------------------------------------------------------------------------
  // 1. Deprecated collection-name remapper
  //    Updates data-suggestions / data-results-url attributes on the form so
  //    legacy collection names are silently rewritten to current ones.
  // ---------------------------------------------------------------------------
  var collectionAliases = [
    ['find.search.qld.gov.au',  'discover.search.qld.gov.au'],
    ['qld-gov',                 'qgov~sp-search'],
    ['qgov-content',            'qgov~sp-content'],
    ['services-web',            'qgov~sp-services'],
  ];

  function remapCollectionName(value) {
    var result = value;
    collectionAliases.forEach(function (pair) {
      if (result.includes(pair[0])) {
        var label = pair[1].includes('qgov~')
          ? '"' + pair[0] + '" collection,'
          : '"' + pair[0] + '"';
        console.log(
          'SWE/Funnelback notice:\nThis application contains a reference to ' +
            label +
            ' which is deprecated. It must be replaced with "' +
            pair[1] +
            '".\n'
        );
      }
      result = result.replace(new RegExp(pair[0], 'g'), pair[1]);
    });
    return result;
  }

  document
    .querySelectorAll(
      'form[data-suggestions], form[data-results-url], div[data-centres], input[name=collection]'
    )
    .forEach(function (el) {
      if (el.hasAttribute('data-suggestions')) {
        el.setAttribute('data-suggestions', remapCollectionName(el.getAttribute('data-suggestions')));
      }
      if (el.hasAttribute('data-results-url')) {
        el.setAttribute('data-results-url', remapCollectionName(el.getAttribute('data-results-url')));
      }
      if (el.hasAttribute('data-centres')) {
        el.setAttribute('data-centres', remapCollectionName(el.getAttribute('data-centres')));
      }
      if (el.getAttribute('name') === 'collection') {
        el.setAttribute('value', remapCollectionName(el.getAttribute('value')));
      }
    });

  // ---------------------------------------------------------------------------
  // 2. Search concierge / autocomplete
  // ---------------------------------------------------------------------------
  (function ($) {
    'use strict';

    var t = { fn: {}, vars: {} };

    // Ensure legacy IDs carry the expected classes
    $('#qg-search-query').hasClass('qg-search-site__input') ||
      $('#qg-search-query').addClass('qg-search-site__input');
    $('#qg-global-search-form').hasClass('qg-site-search__form') ||
      $('#qg-global-search-form').addClass('qg-site-search__form');

    // ------------------------------------------------------------------
    // Input event dispatcher
    // ------------------------------------------------------------------
    t.fn.inputEventHandler = function (e) {
      var type    = e.type,
          $target = $(e.target),
          keyCode = e.keyCode,
          value   = $target.val();

      switch (type) {
        case 'focus':   t.fn.onFocus(value, $target);           break;
        case 'blur':    t.fn.onBlur(value, $target);            break;
        case 'keydown': t.fn.onKeydown(value, keyCode, $target); break;
      }
    };

    t.fn.onFocus = function (value, $input) {
      var $initial = $input.parent().find($('.qg-search-concierge-initial'));
      $input.attr('aria-expanded', 'true');
      value === '' ? $initial.addClass('show') : t.fn.checkForSuggestions(value, $input);
    };

    t.fn.onBlur = function (value, $input) {
      $input.parent().find($('.qg-search-close-concierge')).addClass('hide');
      t.fn.closeConciergePanels($input);
    };

    t.fn.onKeydown = function (value, keyCode, $input) {
      var $initial = $input.parent().find($('.qg-search-concierge-initial')),
          $help    = $input.parent().find($('.qg-search-concierge-help')),
          $close   = $input.parent().find($('.qg-search-close-concierge'));

      if (keyCode === 40) {
        // Arrow-down: move focus into suggestion list
        $input.parents($('.qg-site-search__form')).attr('data-navindex', '0');
        setTimeout($('.qg-search-concierge.show').find('a, button')[0].focus(), 300);
      } else if (value !== '') {
        $close.removeClass('hide');
        t.fn.checkForSuggestions(value, $input);
      } else {
        $close.addClass('hide');
        $initial.addClass('show');
        $help.removeClass('show');
      }

      $initial.hasClass('show') || $help.hasClass('show')
        ? $input.attr('aria-expanded', 'true')
        : $input.attr('aria-expanded', 'false');
    };

    // ------------------------------------------------------------------
    // Keyboard navigation inside the concierge panel
    // ------------------------------------------------------------------
    t.fn.keyboardNavigation = function (e) {
      var $self     = $(this),
          keyCode   = e.keyCode,
          $items    = $self.parents('.qg-site-search__form').find($('.qg-search-concierge.show')).find('a, button'),
          navIndex  = $self.parents('.qg-site-search__form').attr('data-navindex');

      if (keyCode === 40 && $items.length > navIndex - 1) {
        $items[++navIndex].focus();
        $self.parents('.qg-site-search__form').attr('data-navindex', navIndex);
      } else if (keyCode === 38) {
        if (navIndex > 0) {
          $items[--navIndex].focus();
          $self.parents('.qg-site-search__form').attr('data-navindex', navIndex);
        } else {
          $self.parents('.qg-site-search__form').find($('input[type=text].form-control')).focus();
        }
      }
    };

    // ------------------------------------------------------------------
    // Clear input button
    // ------------------------------------------------------------------
    t.fn.clearInputField = function (e) {
      var $closeBtn = $(this).parent().find($('.qg-search-close-concierge'));
      $(this).parent().find($('.qg-search-site__input')).val('');
      $closeBtn.addClass('hide');
      t.fn.closeConciergePanels(e.target);
    };

    // ------------------------------------------------------------------
    // Suggestion click: populate input with selected suggestion text
    // ------------------------------------------------------------------
    t.fn.searchSuggestionClick = function (e) {
      var text = $(e.currentTarget).text();
      $('.qg-search-site__input').val(text);
    };

    // ------------------------------------------------------------------
    // Close panels when clicking/focusing outside the form
    // ------------------------------------------------------------------
    t.fn.handleBodyClick = function (e) {
      if ($(e.target).closest('#qg-global-search-form').length === 0) {
        t.fn.closeConciergePanels(e.target);
      }
    };

    t.fn.handleFocus = function (e) {
      t.fn.closeConciergePanels(e.target);
    };

    t.fn.searchSubmitHandler = function (e) {
      t.fn.closeConciergePanels(e.target);
    };

    // ------------------------------------------------------------------
    // Close all concierge panels with a short animation delay
    // ------------------------------------------------------------------
    t.fn.closeConciergePanels = function () {
      var $initial = $('.qg-search-concierge-initial'),
          $help    = $('.qg-search-concierge-help'),
          $input   = $('.qg-search-site__input');

      $initial.addClass('hide').removeClass('show');
      $help.addClass('hide').removeClass('show');
      $input.attr('aria-expanded', 'false');

      setTimeout(function () {
        $initial.removeClass('hide');
        $help.removeClass('hide');
      }, 300);
    };

    // ------------------------------------------------------------------
    // Trigger API calls once the query is ≥ 3 chars
    // ------------------------------------------------------------------
    t.fn.checkForSuggestions = function (value, $input) {
      var $initial = $input.parent().find($('.qg-search-concierge-initial')),
          $help    = $input.parent().find($('.qg-search-concierge-help'));

      $initial.removeClass('show');
      if (value.length >= 3) {
        t.fn.getSuggestions(value, $input);
        t.fn.getServices(value, $input);
        $help.addClass('show');
      }
    };

    // ------------------------------------------------------------------
    // Fetch type-ahead suggestions from Funnelback suggest.json
    // ------------------------------------------------------------------
    t.fn.getSuggestions = function (query, $input) {
      var suggestUrl = $input.parents('.qg-site-search__form').attr('data-suggestions');
      $.ajax({
        cache:    true,
        dataType: 'json',
        url:      suggestUrl,
        data:     { partial_query: query },
        success: function (data) {
          t.fn.formatSuggestions(data, $input);
        },
      });
    };

    t.fn.formatSuggestions = function (suggestions, $input) {
      var currentVal = $input.parent().find($('.qg-search-site__input')).val(),
          $panel     = $input.parent().find($('.qg-search-concierge-help .qg-search-concierge-group.suggestions')),
          html       = '';

      if (suggestions.length > 0) {
        $input.parent().find($('.qg-search-concierge-help')).show();
        suggestions = suggestions.slice(0, 3);

        html += '<div class="qg-search-concierge-content">';
        html += '<h4>Suggestions</h4>';
        html += '<ul class="list-group">';
        suggestions.forEach(function (item) {
          var disp  = item.disp,
              pos   = disp.indexOf(currentVal.toLowerCase()),
              match = disp.substr(pos, currentVal.length),
              bold  = '<b>' + match + '</b>';

          html += '<li class="list-group-item">';
          html += '<button tabindex="-1" data-analytics-link-group="qg-global-search-suggestion">';
          html += disp.replace(match, bold);
          html += '</button>';
          html += '</li>';
        });
        html += '</ul>';
        html += '</div>';
      } else {
        $input.parent().find($('.qg-search-concierge-help')).hide();
        $input.attr('aria-expanded', 'false');
      }

      $panel.html(html);
    };

    // ------------------------------------------------------------------
    // Fetch related services / featured result from Funnelback search.json
    // ------------------------------------------------------------------
    t.fn.getServices = function (query) {
      var resultsUrl = $('#qg-global-search-form').attr('data-results-url');
      $.ajax({
        cache:    true,
        dataType: 'json',
        url:      resultsUrl,
        data:     { query: query },
        success:  t.fn.processServices,
      });
    };

    t.fn.processServices = function (data) {
      var results  = data.response.resultPacket.results,
          services = [],
          featured = null,
          curator  = data.response.curator;

      if (curator !== undefined) {
        var exhibits = curator.exhibits;
        if (exhibits !== undefined && exhibits.length > 0) {
          featured = exhibits[0];
          for (var i = 1; i < exhibits.length; i++) {
            if (exhibits[i].additionalProperties.service === 'yes') {
              services.push(exhibits[i]);
            }
          }
        }
      }

      if (results.length > 0) {
        var sfinder = results.filter(function (r) {
          return r.listMetadata != null &&
                 r.listMetadata.sfinder != null &&
                 r.listMetadata.sfinder[0] === 'yes';
        });
        services = services.concat(sfinder);
        if (services.length > 3) services = services.slice(0, 3);
      }

      t.fn.formatFeaturedService(featured);
      t.fn.formatServices(services);
    };

    t.fn.formatFeaturedService = function (item) {
      var $panel = $('.qg-search-concierge-help .qg-search-concierge-group.highlight'),
          html   = '';

      if (item) {
        var title = item.titleHtml,
            url   = item.displayUrl,
            desc  = item.descriptionHtml,
            props = item.additionalProperties;

        html += '<div class="qg-search-concierge-content">';
        html += '<div class="d-flex justify-content-between align-content-center flex-wrap">';
        html += '<h4>' + title + '</h4>';

        if (props.icon !== undefined) {
          html += '<div>' +
            props.icon.split(' ').map(function (cls) {
              return '<span class="fa ' + cls + '"></span>';
            }).join('') +
            '</div>';
        }

        html += '</div>';
        html += '<p>' + desc + '</p>';

        if (url) {
          var btnText = props.buttonText || 'Continue';
          html += '<a href="' + url + '" tabindex="-1" data-analytics-link-group="qg-global-search-feature" class="btn btn-global-primary-white">' + btnText + '</a>';
        }

        html += '</div>';
      }

      $panel.html(html);
    };

    t.fn.formatServices = function (items) {
      var $panel = $('.qg-search-concierge-help .qg-search-concierge-group.helper'),
          html   = '';

      if (items.length > 0) {
        html += '<div class="qg-search-concierge-content">';
        html += '<h4>Related services</h4>';
        html += '<ul class="list-group">';

        items.forEach(function (item) {
          var title = item.title !== undefined
            ? item.title.split('|')[0].trim()
            : item.titleHtml;
          var url = item.liveUrl !== undefined ? item.liveUrl : item.displayUrl;

          html += '<li class="list-group-item">';
          html += '<a href="' + url + '" tabindex="-1" data-analytics-link-group="qg-global-search-related-service">' + title + '</a>';
          html += '</li>';
        });

        html += '</ul>';
        html += '</div>';
      }

      $panel.html(html);
    };

    // ------------------------------------------------------------------
    // Wire up events (debounced input handler + body/form delegates)
    // ------------------------------------------------------------------
    $(document).ready(function () {
      var lastImmediate, debounceTimer;

      $('.qg-search-site__input').on(
        'focus keydown',
        (function (handler, delay) {
          return function () {
            var ctx  = this,
                args = arguments,
                callNow = lastImmediate && !debounceTimer;

            clearTimeout(debounceTimer);
            debounceTimer = setTimeout(function () {
              debounceTimer = null;
              if (!lastImmediate) handler.apply(ctx, args);
            }, delay);

            if (callNow) handler.apply(ctx, args);
          };
        })(t.fn.inputEventHandler, 200)
      );
    });

    $('body').on('focusin',  '.qg-navigation .nav-link, .qg-service-finder__popular-apps a, .qg-coat-of-arms a', t.fn.handleFocus);
    $('body').on('click',    t.fn.handleBodyClick);
    $('body').on('click',    '.qg-search-close-concierge',                          t.fn.clearInputField);
    $('body').on('click',    '.qg-search-concierge-group.suggestions button',       t.fn.searchSuggestionClick);
    $('body').on('submit',   '#qg-global-search-form',                              t.fn.searchSubmitHandler);
    $('body').on('keydown',  '.qg-search-concierge-group a, .qg-search-concierge-group button', t.fn.keyboardNavigation);

  })(jQuery);

})();
